module.exports = __webpack_public_path__ + "static/media/2014-Ford-Ranger-Resized.bd584ef0.webp";